import { render, staticRenderFns } from "./patientManagementDialogs.vue?vue&type=template&id=36457a01&scoped=true&"
import script from "./patientManagementDialogs.vue?vue&type=script&lang=js&"
export * from "./patientManagementDialogs.vue?vue&type=script&lang=js&"
import style0 from "./patientManagementDialogs.vue?vue&type=style&index=0&id=36457a01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36457a01",
  null
  
)

export default component.exports